<section class="calculation-model-search-area-search-form">
    <div class="search-label">
        <label>{{'calculationModel.name' | translate | uppercase}}</label>
        <kendo-textbox #nameField style="width:100%" class="search-field" [(ngModel)]="searchModel.name"
            (ngModelChange)="triggerSearch()">
        </kendo-textbox>
    </div>
    <div class="search-label">
        <label>{{'calculationModel.country' | translate | uppercase}}</label>
        <kendo-dropdownlist [data]="countryRefList" class="search-field" style="width:100%" textField="description"
            valueField="description" [valuePrimitive]="true" [(ngModel)]="searchModel.country"
            (ngModelChange)="triggerSearch()">
        </kendo-dropdownlist>
    </div>
    <div class="search-label">
        <label class="search-label">{{'calculationModel.status' | translate | uppercase}}</label>
        <kendo-dropdownlist [data]="statusRefList" class="search-field" style="width:100%" textField="description"
            valueField="description" [valuePrimitive]="true" [(ngModel)]="searchModel.status"
            (ngModelChange)="triggerSearch()">
        </kendo-dropdownlist>

    </div>
    <div class="search-label">
        <label class="search-label">{{'calculationModel.sector' | translate}}</label>
        <kendo-dropdownlist [data]="sectorRefList" class="search-field" style="width:100%" textField="description"
            valueField="description" [valuePrimitive]="true" [(ngModel)]="searchModel.sector"
            (ngModelChange)="triggerSearch()" >
        </kendo-dropdownlist>

    </div>
    <div class="search-label">
        <label class="search-label">{{'calculationModel.valuationMethod' | translate | uppercase}}</label>
        <kendo-dropdownlist [data]="valuationMethodRefList" class="search-field" style="width:100%"
            textField="description" valueField="description" [valuePrimitive]="true"
            [(ngModel)]="searchModel.valuationMethod" (ngModelChange)="triggerSearch()">
        </kendo-dropdownlist>
    </div>
</section>
